/**
 * Arc length scaling for miller weld machine
 *
 * See section 3.4.1.9
 */
export const convertArcLength = {
  /**
   * Convert arc length to weld machine format.
   * @param arcLength Length in [-10,10]
   * @returns Arc length input in [0,200]
   */
  toWeldMachine: (arcLength: number) => Math.round((arcLength + 10) * 10),

  /**
   * Convert arc length from weld machine format.
   * @param received From machine in [0,200]
   * @returns Arc length in [-10,10]
   */
  fromWeldMachine: (received: number) => received / 10 - 10,
};
